export default __webpack_public_path__ + "static/media/icon-eye-crossed-inactive.30634926.svg";